import { render, staticRenderFns } from "./Enterprises.vue?vue&type=template&id=a22b60a8&"
import script from "./Enterprises.vue?vue&type=script&lang=js&"
export * from "./Enterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports